/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Jan 05 2021
 *  File : index.jsx
 *******************************************/
import PreAuthMap from './PreAuthMap';

export default PreAuthMap;